import { container } from './ioc/ioc.config';
import { apiServices } from './ioc/services';
/**
 * @doc getApi
 * @description Provides instantiated api with default params.
 *
 * @example
 *
 * import { getApi } from '@wix/video-maker-api';
 *
 * const { videoMakerApi, videoMakerJobQueue } = getApi();
 *
 * videoMakerApi.getMusicTags()
 *   .subscribe(tags => {
 *     console.log('Music Tags', tags);
 *   });
 *
 * videoMakerJobQueue.addJob({ sessionId: 34343 })
 *   .pipe(
 *     filter(jobStatus => jobStatus.status === JobStatus.DONE),
 *     tap(() => console.log('Video creation is done')),
 *   );
 *
 */
export function getApi() {
    return {
        videoMakerApi: container.get(apiServices.videoMakerApi),
        videoMakerJobQueue: container.get(apiServices.videoMakerJobQueue),
    };
}
//# sourceMappingURL=getApi.js.map